import requests from "./httpService";
import {  categoryMap , expandCosts} from "utils/parkingCost";

// function collapseCosts(costs) {
//   const grouped = {
//     Sedan: 0,
//     "SUV & MUV": 0,
//     "Tempo Traveller": 0,
//   };

//   Object.entries(costs || {}).forEach(([name, value]) => {
//     const lower = name.toLowerCase();

//     if (lower === "sedan" && grouped.Sedan === 0) {
//       grouped.Sedan = Number(value);
//     } else if (["suv", "muv", "crysta"].includes(lower) && grouped["SUV & MUV"] === 0) {
//       grouped["SUV & MUV"] = Number(value);
//     } else if (lower.includes("tempo traveller") && grouped["Tempo Traveller"] === 0) {
//       grouped["Tempo Traveller"] = Number(value);
//     }
//   });

//   return grouped;
// }

const ParkingServices = {
  
  addParking: async (body) => {
    return requests.post("/parking/add", body);
  },

  getAllParking: async () => {
    const res = await requests.get("/parking/");
    return res.data;
  },

  getParkingById: async (id, body) => {
    return requests.get(`/parking/${id}`, body);
  },

  updateParking: async (id, body) => {
    return requests.put(`/parking/update/${id}`, body);
  },

  deleteParking: async (id) => {
    return requests.delete(`/parking/delete/${id}`);
  },

   getAllCategories: async () => {
    const res = await requests.get("/vehicleCategory/");
    return res.data.map((cat) => ({
      id: cat.id,
      seats: cat.seats,
    }));
  },

checkSightSeeing: async (cityId, sightSeeing) => {
    try {
      const res = await requests.get(`/parking/${cityId}`, {
        params: { sight_seeing: sightSeeing },
      });
      // console.log("api response checkplace",res);
      return res; 
    } catch (error) {
      console.error("Error in checkSightSeeing:", error);
      throw error;
    }
  },

bulkUpload: async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return requests.post("/parking/bulk-upload/parkingList", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
},
};

export default ParkingServices;
